import React, { useState } from "react";
import classnames from "classnames";
import { Bars } from "ceicons";
import { Accordion } from "semantic-ui-react";
import User from "./User";
import Entry from "./Entry";
import CecoLogo from "../../../assets/img/logo_recetario.png";
import "./Menu.scss";

function Menu(props) {
  const {
    logo,
    auth,
    roleMode,
    expanded,
    setExpanded,
    routes = [],
    version,
    onLogoutClick,
    pathname = window.location.pathname,
  } = props;

  const [activeAccordion, setActiveAccordion] = useState(
    getActiveAccordion(pathname, routes)
  );

  return (
    <div
      className={classnames("cecoadmin-menu", {
        expanded,
      })}
    >
      <div className="cecoadmin-menu__header">
        <div className="cecoadmin-menu__header-logo">
          <Bars onClick={() => setExpanded(!expanded)} />
          {expanded && (
            <div className="logo_wrapper">
              <img src={logo || CecoLogo} alt="Cecotec" />
              {version && <span>v{version}</span>}
            </div>
          )}
        </div>
      </div>
      <div className="cecoadmin-menu__body">
        <Accordion>
          {routes.map((data, index) => {
            return (
              <Entry
                key={index}
                index={index}
                data={data}
                auth={auth}
                roleMode={roleMode}
                expanded={expanded}
                setExpanded={setExpanded}
                activeAccordion={activeAccordion}
                setActiveAccordion={setActiveAccordion}
              />
            );
          })}
        </Accordion>
      </div>
      <div className="cecoadmin-menu__footer">
        <User
          user={auth?.user}
          expanded={expanded}
          onLogoutClick={onLogoutClick}
        />
      </div>
    </div>
  );
}

export default Menu;

const getActiveAccordion = (pathname, routes) => {
  for (let i = 0; i < routes.length; i++) {
    if (!routes[i].children) {
      continue;
    }
    for (let j = 0; j < routes[i].children.length; j++) {
      if (routes[i].children[j].path === pathname) {
        return i;
      }
    }
  }
  return -1;
};
